<template>
  <section class="text-w-cta" :class="{'large-x-padding': data.twc_large_padding}">
    <div class="text-w-cta-subheaders">
      <h3
      :class="{'subheader-medium': data.font_size === '70px'}"
      >
        {{ data.subheader }}
      </h3>
      <span>{{ data.optional_subheader }}</span>
    </div>
    <h2
      v-html="data.header"
      :class="{'font-medium': data.font_size === '70px'}"
    />
    <div v-if="data.cta">
        <Button
        v-if="data.button_is_white"
        :url="data.cta.url"
        :text="data.cta.title"
        color="white"
        lineHover="bg-orange"
        circleColor="circle-white"
        />
        <Button
        v-else
        :url="data.cta.url"
        :text="data.cta.title"
        color="dark-green"
        lineHover="bg-mint-30"
        circleColor="circle-orange"
        />
    </div>
  </section>
</template>

<script setup>
import Button from '@/components/utility/Button.vue'
defineProps(['data'])
</script>

<style lang="scss" scoped>
.text-w-cta {
  @apply main-container py-8 flex flex-col
  sm:py-12
  xl:py-3
  xl:px-[150px]
  ;
  &.large-x-padding{
    @apply
    xl:px-64;
  }
  &-subheaders{
    @apply flex items-end gap-[35px]
    mobile:gap-[85px]
    xl:gap-36;
      h3 {
        @apply p-0 sm:text-xl;
      }
      .subheader-medium {
        @apply max-w-[50%] text-3xl leading-[30px]
        md:max-w-[35%]
        xl:text-[40px] xl:leading-[40px];
      }
      span {
        @apply text-xl leading-none mb-[2px]
        xl:mb-[4px]
        ;

      }
  }
  h2 {
    @apply text-[36px] leading-9 my-9 font-[400]
    sm:text-[70px] sm:leading-[70px] sm:my-11
    lg:text-[100px] lg:leading-[100px] lg:mb-24;
  }
  .font-medium {
    @apply text-[36px] leading-[36px]
    sm:text-[60px] sm:leading-[60px]
    lg:text-[70px] lg:leading-[70px];
  }

  .button {
    @apply m-0 p-0;
  }
}
</style>
